import type { LocationQueryRaw } from "vue-router";

const MOBILE_USER_AGENT_RE =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i;

const H5_SAFE_PATH_PREFIXES = ["/h5", "/wechatcallback"];

const STATIC_PC_TO_H5_MAP: Record<string, string> = {
  "/": "/h5/supply-mall",
  "/supply-mall": "/h5/supply-mall",
  "/category": "/h5/supply-mall",
  "/search": "/h5/supply-mall",
  "/checkout": "/h5/checkout",
  "/orders": "/h5/orders",
  "/profile": "/h5/orders",
  "/favorites": "/h5/supply-mall",
  "/odm": "/h5/desktop-only",
  "/sales-quote": "/h5/sales-quote",
  "/sales-quote/checkout": "/h5/sales-quote/checkout",
};

const DESKTOP_ONLY_PREFIXES = [
  "/ai-tools",
  "/print3d",
  "/compute",
  "/task-center",
];

function isMobileRequest() {
  if (import.meta.client) {
    return MOBILE_USER_AGENT_RE.test(window.navigator.userAgent);
  }

  const headers = useRequestHeaders(["user-agent"]);
  return MOBILE_USER_AGENT_RE.test(headers["user-agent"] || "");
}

function withQuery(path: string, query: LocationQueryRaw) {
  return { path, query, replace: true };
}

export default defineNuxtRouteMiddleware((to) => {
  if (!isMobileRequest()) return;

  if (H5_SAFE_PATH_PREFIXES.some((prefix) => to.path.startsWith(prefix))) {
    return;
  }

  if (to.path.startsWith("/product/")) {
    const spu = to.path.split("/").filter(Boolean)[1];
    if (spu) return navigateTo(withQuery(`/h5/product/${spu}`, to.query));
  }

  if (to.path.startsWith("/ai-product/")) {
    const spu = to.path.split("/").filter(Boolean)[1];
    if (spu) return navigateTo(withQuery(`/h5/product/${spu}`, to.query));
  }

  if (to.path.startsWith("/ai-custom/")) {
    const spu = to.path.split("/").filter(Boolean)[1];
    if (spu) {
      return navigateTo(
        withQuery(`/h5/product/${spu}`, { ...to.query, desktopTip: "1" }),
      );
    }
    return navigateTo(withQuery("/h5/desktop-only", to.query));
  }

  if (DESKTOP_ONLY_PREFIXES.some((prefix) => to.path.startsWith(prefix))) {
    return navigateTo(withQuery("/h5/desktop-only", to.query));
  }

  const mappedPath = STATIC_PC_TO_H5_MAP[to.path];
  if (mappedPath) return navigateTo(withQuery(mappedPath, to.query));
});
